module.exports = __webpack_public_path__ + "static/media/bf1.274828ba.png";